import { Box, SxProps } from '@mui/material';

import { Header } from '@/types/generated';

import NavigationBarItem from './NavigationBarItem';

interface INavigationBar {
	navigationItems: Header['navigationLinksCollection'] | Header['secondaryNavigationLinksCollection'];
	navigationSx?: SxProps;
	navigationLinkSx?: SxProps;
	linkColor?: string;
	fontWeight?: string | number;
	showIconText?: boolean;
}

export default function NavigationBar({
	navigationItems,
	navigationSx,
	navigationLinkSx,
	linkColor,
	fontWeight,
	showIconText = false,
}: Readonly<INavigationBar>) {
	return (
		<Box data-test-id="header_with_location_nav_main_navigation_bar" sx={navigationSx}>
			{navigationItems?.items?.map((item, index) =>
				item ? (
					<NavigationBarItem
						key={item.sys.id}
						item={item}
						itemIndex={index}
						navLinkStyles={navigationLinkSx}
						linkColor={linkColor}
						fontWeight={fontWeight}
						showIconText={showIconText}
					/>
				) : null
			)}
		</Box>
	);
}
